import { DataGrid, GridColDef } from "@mui/x-data-grid";
import SectionCard from "../../../components/SectionCard";
import { useDashboard } from "../../../context/HDBDashboardContext";
import styles from "./index.module.scss";

const DetailedTable = ({ detailedData }) => {
  const { columnDefinition, values, displayName } = detailedData || {};
  const { updateFilters } = useDashboard()

  if (!columnDefinition || !values) return null;

  const columns: GridColDef[] = columnDefinition.map((col) => ({
    field: col.key,
    headerName: col.displayName,
    flex: 1,
  }));

  const rows = values.map((row, index) => ({
    id: index,
    ...row,
  }));
  console.log("rows", rows);
  const handleCellClick = (params) => {
    const {field, row} = params;
    const filter = row.filters?.[field];
    if (filter) {
      updateFilters(filter);
    }
  };

  return (
    <SectionCard title={displayName} customClass={styles.detailedTableCard}>
      <div className={styles.tableWrapper}>
        <DataGrid
          rows={rows}
          columns={columns}
          autoHeight
          // pageSize={5}
          onCellClick={handleCellClick}
          // rowsPerPageOptions={[5]}
          // disableSelectionOnClick
          hideFooter
          sx={{
            border: "none",
            "& .MuiDataGrid-columnHeaders": {
              borderBottom: "none",
              color: "#888888", // 👈 header text color
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
              cursor: "pointer",
            },

          }}
        />
      </div>
    </SectionCard>
  );
};

export default DetailedTable;
